import { render } from "./BankingSecurityPage.vue?vue&type=template&id=0affd7d6"
import script from "./BankingSecurityPage.vue?vue&type=script&lang=js"
export * from "./BankingSecurityPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__